<template>
  <div>
    <el-row>
      <el-col :span="12" class=".el-col-frame-left">
        <el-card class="box-card userInfo head">
          <div slot="header" class="userInfo-header clearfix">
            <span>班级信息</span>
          </div>
          <el-row class="userInfo-body">
            <el-col :span="12" class="userHead">
              <img   style="width: 260px;height: 200px;" :src="user.head"   v-if="user.head" ></img>
              <img   style="width: 260px;height: 200px;" src="~assets/img/study.png"   v-else ></img>
              <div style="font-weight: bold"></div>
            </el-col>
            <el-col :span="12" class="info">
              <div>
                <label>班级名称:</label>
                <span> {{ myClass.name }}</span>
              </div>
              <div>
                <label>学生名字:</label>
                <span> {{ user.name }}</span>
              </div>
              <div  v-if="myClass.subject">
                <label>专业:</label>
                <span> {{ user.subject }}</span>
              </div>

              <div>
                <label>手机号码:</label>
                <span> {{ user.mobile }}</span>
              </div>
              <div>
                <label>所报课程:</label>
                <span> {{ myClass.dbColumn_cid }}</span>
              </div>
              <div>
                <label>带班老师:</label>
                <span> {{ myClass.dbColumn_tid }}</span>
              </div>
              <div v-if="myClass.monitor">
                <label>班长:</label>
                <span> {{ myClass.monitor }}</span>
              </div>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="12" class="el-col-frame-right">
        <el-card class="head_card head">
          <el-row>
            <el-col :span="8" v-show="tableData" v-for="(v, index) in tableData" :key="v.id">
              <el-card class="box-card userInfo title">
                <el-avatar :size="120" fit="fill">
                  
                  <img v-if="v.head" :src="v.head" style="width:120px;">
                  <img v-else src="~assets/img/npro.png" style="width:120px;">
                </el-avatar>
                <div>{{ index + 1 }}.{{ v.name }}</div>
                 <el-tag size="mini" v-if="v.team" :type="v.groupleader==1?'success':'primary'">第{{v.team}}组{{ v.groupleader==1?'~组长':'' }}</el-tag>
                 <el-tag size="mini" v-else type="danger">未分组</el-tag>
                 <el-tag size="mini" v-if="v.name==myClass.monitor" type="danger">班长</el-tag>
                </el-card>
            </el-col>
            <el-col v-show="!tableData.length" :span="24">
              <el-card class="box-card userInfo title">
                无学生
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import "echarts/lib/chart/bar";
import api from "@/api/study/myclass2/myclass2.js";


export default {
  name: "myclass",
  data() {
    return {
      myClass: {},
      user: {},
      dateFlag0: 0,
      classList: [],          //班级列表
      SummarizeAll: {},
      tableData: [],        //当前班级的全部学生
    };
  },
  methods: {

    //获取学生
     getStudent() {
      api.getStudent({}, (response) => {

        this.user = response.data.stu
        this.myClass = response.data.clz
        this.currentClassCid = this.myClass.cid;
        this.getStudengtList();
      });
    },
    //获取学生列表
    getStudengtList() {
      let params = { cid: this.user.cid };
      api.getStudentList(params, (response) => {
        this.tableData = response.data;
      });
    }
  },

  mounted() {
    //this.getClassOne();
    this.getStudent();
  }
};
</script>

<style lang="scss" scoped="scoped">
.el-col-frame-left {
  background-color: rgb(212, 248, 248);
}

.head{
  height: 500px !important;
}
.head_card {
  overflow: auto;

  .title {
    text-align: center;
  }
}

@import "~common/custom/css/common.scss";
@import "~common/custom/css/main.scss";
</style>

